import { useNavigate } from 'react-router-dom';

export const useNavigateTop = () => {
    const navigate = useNavigate();

    return (to: string) => {
        navigate(to);
        // Added setTimeout to fix a bug where scrollTo was not working on FireFox
        setTimeout(() => window.scrollTo(0, 0), 1);
    };
};
